import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
// let baseUrl = '/api/kj-gy-apartment'

let api = {
  // 修改园区信息
  updateyqInfo: `${baseUrl}/gyInfo/update`,

  // 获取园区信息
  getYqInfo: `${baseUrl}/gyInfo/getYqInfo`,

  // 修改园区账户信息
  updateyqAppInfo: `${baseUrl}/yqAppInfo/update`,

  // 修改园区账户信息
  getYqAppInfo: `${baseUrl}/yqAppInfo/getYqAppInfo`,

  // 获取支付宝账户列表
  getAliAccountList: `${baseUrl}/aliAccount/getList`,

  // 上传图片
  uploadImg: `${baseUrl}/yqNews/uploadImg`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/ConfigRoutine.js